import { registerEvent } from '@/services/webApi';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export default function useRegisterEventMutation({
  eventId,
  onSuccess,
  onError
}: {
  eventId: string;
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['registerEvent', eventId],
    mutationFn: registerEvent,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['event', eventId]
      });
      queryClient.invalidateQueries({
        queryKey: ['eventRegistrationCount', eventId]
      });
      queryClient.invalidateQueries({
        queryKey: ['account']
      });
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    }
  });
}
